import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
    openModal: false,
    data: null
};

export const maintenanceWarningsConfirmResolveRedux = createSlice({
    name: 'devices/maintenanceWarnings/resolveMaintenanceWarningEvent',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalResolveMaintenanceWarningEvent(state, action) {
            state.openModal = true
            state.data = action.payload
        }
    }
})

const { actions, reducer } = maintenanceWarningsConfirmResolveRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalResolveAllMaintenanceWarningEvent,
    openModalResolveMaintenanceWarningEvent
} = actions;

export default reducer;
